import { observable, makeObservable } from 'mobx';
import { useStores } from '../useStores';
import withActions from '../withActions';
import actions from './actions';

export default class AppClientStore {
    version = '2.0';

    observed = {
        progress: false,
    };
    
    constructor() {
        makeObservable(this, {
            observed: observable,
        });

        withActions(this, actions);
        this.observeClientPage();
    }

}

export function useAppClientStore () {
    const { store } = useStores();
    return store.appClientStore;
}
